import classes from "./AccountLiked.module.css";
import DUMMY_DATA from "../../dummyData.json";
import { Link } from "react-router-dom";

const AccountLiked = () => {
  let products = DUMMY_DATA.filter((product) => product.isLiked === "true").map(
    (product) => {
      return (
        <li key={product.id}>
          <Link to={`/product/${product.id}`}>
            <img src={product.img} alt="" />
            {/* <div>{product.itemName}</div> */}
          </Link>
        </li>
      );
    }
  );
  return <ul className={classes.likedItem}>{products}</ul>;
};

export default AccountLiked;
